import { useEffect, useState } from "react";
import { Heart, Mic2 } from "lucide-react";
import { http, fmtRupee } from "../api";
import AudioPlayer from "../components/AudioPlayer";

export default function Shortlist() {
  const [items, setItems] = useState([]);
  const load = () => http.get("/favorites").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const remove = async id => { await http.post(`/favorites/${id}`); load(); };
  return (
    <>
      <div className="page-head"><div><h1>My shortlist</h1><p>Your favourite voices, ready to compare.</p></div></div>
      <div className="voice-grid">
        {items.map(v => (
          <article className="voice-card" key={v.id} data-testid={`shortlist-item-${v.id}`}>
            <div className="voice-top">
              <div className="voice-id">
                <div className="voice-avatar"><Mic2 size={18} /></div>
                <div><strong>{v.public_id}</strong><small>{v.gender} · {v.voice_age}</small></div>
              </div>
              <button className="star-btn active" onClick={() => remove(v.id)}><Heart size={16} fill="currentColor" /></button>
            </div>
            <AudioPlayer id={v.id} compact />
            <div className="voice-meta"><span>{v.language}</span><span>{v.category}</span></div>
            <div className="voice-bottom">
              <div className="voice-price"><strong>{fmtRupee(v.marketplace_rate)}</strong><small>per finished hour</small></div>
              <div className="voice-rating">{v.rating > 0 ? v.rating.toFixed(1) : "New"} <small>({v.review_count || 0})</small></div>
            </div>
          </article>
        ))}
        {items.length === 0 && <div className="empty" style={{ gridColumn: "1 / -1" }}><Heart size={30} /><div style={{ fontWeight: 600, marginTop: 8 }}>No shortlisted voices yet</div><div style={{ fontSize: 13 }}>Tap the heart on any marketplace voice.</div></div>}
      </div>
    </>
  );
}
